import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class TemplateDefault extends Vue {
  @Prop({ default: false })
  public showOrderConfirmationMessage!: boolean;
  @Prop({ default: false })
  public isInclusion!: boolean;
  @Prop({ default: false })
  public isProFit!: boolean;
  @Prop({ default: '' })
  public confirmationMessage!: string;
}
